import * as App from '../app/constants'
import {LOCATION_CHANGE, ON_ENTER} from './constants'
import {State} from './types'

export const reducer = (state: State = null, action: any) => {
  switch (action.type) {
    case App.INITIALIZING_APPLICATION:
      return action.router
    case ON_ENTER:
      return {
        ...state,
        params: action.params,
      }
    case LOCATION_CHANGE:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/router/reducer.ts